/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {AbstractResourceService, JsonApiResource} from '@irian-ro/abstract-resource';
import {EnvironmentService} from "@irian-ro/util-environment";
import {
  LegalEntityTermsAndConditionsCompanyVO,
  LegalEntityTermsAndConditionsDto, LegalEntityTermsAndConditionsVersionSummaryVO, LegalEntityTermsAndConditionsCompanyMetadataModel, LegalEntityTermsAndConditionsVersionSummaryMetadataModel
} from '@well/domain';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LegalEntityTermsAndConditionsResourceService extends AbstractResourceService<any, LegalEntityTermsAndConditionsDto, any, any> {

  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('legalEntityTermsAndConditionsUrl'),
      undefined,
      LegalEntityTermsAndConditionsDto
    );
  }

  saveLE_TermsAndConditionsMajorVersion(leTermsAndConditions: LegalEntityTermsAndConditionsDto): Observable<JsonApiResource<LegalEntityTermsAndConditionsDto, any>>{
    return <Observable<JsonApiResource<LegalEntityTermsAndConditionsDto, any>>>this.httpClient?.post(`${this.url}/major`, leTermsAndConditions, {headers: this.headers});
  }

  saveLE_TermsAndConditionsMinorVersion(leTermsAndConditions: LegalEntityTermsAndConditionsDto): Observable<JsonApiResource<LegalEntityTermsAndConditionsDto, any>>{
    return <Observable<JsonApiResource<LegalEntityTermsAndConditionsDto, any>>>this.httpClient?.post(`${this.url}/minor`, leTermsAndConditions, {headers: this.headers});
  }

  getLE_TermsAndConditionsTemplateFromExisting(uuid: string): Observable<JsonApiResource<LegalEntityTermsAndConditionsDto, any>> {
    return <Observable<JsonApiResource<LegalEntityTermsAndConditionsDto, any>>>this.httpClient?.get(`${this.url}/template/${uuid}`);
  }

  getLE_TermsAndConditionsCompaniesForCurrentOwnerAndLanguage(documentLanguage: string): Observable<JsonApiResource<LegalEntityTermsAndConditionsCompanyVO[], LegalEntityTermsAndConditionsCompanyMetadataModel>> {
    return <Observable<JsonApiResource<LegalEntityTermsAndConditionsCompanyVO[], LegalEntityTermsAndConditionsCompanyMetadataModel>>>this.httpClient?.get(`${this.url}/${documentLanguage}/companies/vos`);
  }

  getLE_TermsAndConditionsVersionsSummaryFor(forLeUuid: string, documentType: string, documentLanguage: string): Observable<JsonApiResource<LegalEntityTermsAndConditionsVersionSummaryVO[], LegalEntityTermsAndConditionsVersionSummaryMetadataModel>> {
    if(forLeUuid === null){
      return <Observable<JsonApiResource<LegalEntityTermsAndConditionsVersionSummaryVO[], LegalEntityTermsAndConditionsVersionSummaryMetadataModel>>>this.httpClient?.get(`${this.url}/${documentType}/${documentLanguage}/versions/vos`);
    }else{
      return <Observable<JsonApiResource<LegalEntityTermsAndConditionsVersionSummaryVO[], LegalEntityTermsAndConditionsVersionSummaryMetadataModel>>>this.httpClient?.get(`${this.url}/${forLeUuid}/${documentType}/${documentLanguage}/versions/vos`);
    }
  }
}
